import { render, staticRenderFns } from "./AppReloadMessage.vue?vue&type=template&id=753e7278&scoped=true&"
import script from "./AppReloadMessage.vue?vue&type=script&lang=js&"
export * from "./AppReloadMessage.vue?vue&type=script&lang=js&"
import style0 from "./AppReloadMessage.vue?vue&type=style&index=0&id=753e7278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753e7278",
  null
  
)

/* custom blocks */
import block0 from "./AppReloadMessage.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports